module.exports = __webpack_public_path__ + "img/diners-club.32d357fc.svg";